import Axios from "../config/config";

//sub admin 
export const SUB_ADMIN_LIST = async (body) => {
    try {
        const response = await Axios.post('sub-admin-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const SUB_ADMIN_STATUS = async (body) => {
    try {
        const response = await Axios.post('sub-admin-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_SUB_ADMIN = async (body) => {
    try {
        const response = await Axios.post('add-sub-admin/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_SUB_ADMIN = async (body) => {
    try {
        const response = await Axios.post('edit-sub-admin/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_SUB_ADMIN = async (body) => {
    try {
        const response = await Axios.post('view-sub-admin/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const ASSIGN_SUBADMIN_AS_LEARNER = async (body) => {
    try {
        const response = await Axios.post('assign-subadmin-as-learner/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};